import { useState } from "react";
import { SORT_TYPE } from "Constants/constant";
import ExportQueuedModal from "./ExportHistory/ExportQueuedModal";
import { executeReportExport } from "./reportExportUtils";

/**
 * Hook for reporting pages — handles large async exports + queued modal.
 * Pass sortBy/sortDescending so exports match the active table sort.
 */
const useReportExport = (
  reportType,
  reportLabel,
  { sortBy, sortDescending } = {}
) => {
  const [queuedExport, setQueuedExport] = useState(null);
  const [showQueuedModal, setShowQueuedModal] = useState(false);

  const getExportSortFilters = (filters = {}) => ({
    sort_field: filters.sort_field ?? sortBy,
    sort_order:
      filters.sort_order ??
      (sortDescending ? SORT_TYPE.DESC : SORT_TYPE.ASC),
  });

  const runExport = async ({
    format,
    payload,
    syncUrl,
    totalRows,
    setLoader,
    onSyncExcel,
    onSyncPdf,
    filters = {},
    fallbackTotal,
  }) =>
    executeReportExport({
      reportType,
      reportLabel,
      format,
      payload,
      syncUrl,
      totalRows,
      setLoader,
      onSyncExcel,
      onSyncPdf,
      sortBy,
      sortDescending,
      filters,
      fallbackTotal,
      onQueued: (exportData) => {
        setQueuedExport(exportData);
        setShowQueuedModal(true);
      },
    });

  const QueuedModal = () => (
    <ExportQueuedModal
      isOpen={showQueuedModal}
      onClose={() => setShowQueuedModal(false)}
      exportRecord={queuedExport}
    />
  );

  return { runExport, QueuedModal, getExportSortFilters };
};

export default useReportExport;
